import { render } from "./inputBox.vue?vue&type=template&id=8f50c780&scoped=true"
import script from "./inputBox.vue?vue&type=script&lang=js"
export * from "./inputBox.vue?vue&type=script&lang=js"

import "./inputBox.vue?vue&type=style&index=0&id=8f50c780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f50c780"]])

export default __exports__